import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/**
 * @overview TagInput accepts multiple values that can be individually removed
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '../../badges';
import { Icon } from '../../icon';
import { minorScale } from '../../scales';

var Tag =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Tag, _React$PureComponent);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tag).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onRemove = _this$props.onRemove,
          isRemovable = _this$props.isRemovable,
          props = _objectWithoutProperties(_this$props, ["children", "onRemove", "isRemovable"]);

      var badgeStyles = {
        alignItems: 'center',
        display: 'inline-flex',
        fontWeight: 400,
        textTransform: 'none'
      };

      if (isRemovable) {
        badgeStyles.paddingRight = minorScale(1);
      }

      return React.createElement(Badge, _extends({
        isInteractive: true
      }, badgeStyles, props), children, isRemovable && React.createElement(Icon, {
        icon: "cross",
        marginLeft: minorScale(1),
        onClick: onRemove,
        size: minorScale(3)
      }));
    }
  }]);

  return Tag;
}(React.PureComponent);

Tag.displayName = "Tag";

_defineProperty(Tag, "propTypes", {
  /** The badge content */
  children: PropTypes.node,

  /**
   * Callback invoked when the removal icon is clicked.
   * (event) => void
   */
  onRemove: PropTypes.func,

  /** Whether or not the tag can be removed. */
  isRemovable: PropTypes.bool
});

export default Tag;